/* @ngInject */
const myAxletreeForm = (
  $$axletree,
  constants
) => {
  return {
    restrict: 'E',
    scope: {
      myAxletree: '=',
      myIndex: '=',
      enableValidator: '=?',
      defaultWeight: '=',
    },
    template: require('./myAxletreeForm.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.fieldsOptions = $$axletree.metadata.fields

      $scope.positions = constants.arrays.positions
      $scope.decisions = constants.arrays.decisions
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myAxletreeForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/axletree/directives/forms/myAxletreeForm.js